import { createContext, useState, useEffect } from 'react';
import i18n from './i18n';
export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(i18n.language || 'en');

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLanguage(lng);
    localStorage.setItem('lang', lng);
  };

  useEffect(() => {
    const storedLang = localStorage.getItem('lang');
    if (storedLang) changeLanguage(storedLang);
  }, [localStorage.getItem('lang')]);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
